import { render, staticRenderFns } from "./brandFollowData.vue?vue&type=template&id=17bdc260&"
import script from "./brandFollowData.vue?vue&type=script&lang=js&"
export * from "./brandFollowData.vue?vue&type=script&lang=js&"
import style0 from "./brandFollowData.vue?vue&type=style&index=0&id=17bdc260&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports